global.langCode = {
  'zh-hans': 'zh',
  en: 'en',
  km: 'km',
  fr: 'fr',
  lo: 'lo',
  mn: 'mn',
  th: 'th',
};

global.langText = {
  en: 'English',
  km: 'Khmer',
  'zh-hans': 'Chinese',
  th: 'Thai',
  fr: 'French',
};

global.listingStatus = {
  current: 'Live',
  sold: 'Sold',
  leased: 'Leased',
  withdrawn: 'Withdrawn',
  expired: 'Expired',
  deleted: 'Deleted',
  pending_approval: 'Unavailable',
};

global.ratingMoreFeedback = {
  buyer: {
    quick_responder: 'Quick Responder',
    correctly_described: 'Property as Described',
    unhelpful: 'Unhelpful',
  },
  seller: {
    hot_lead: 'Hot Lead',
    just_browsing: 'Just Browsing',
    spam: 'Spam',
  },
};
